module.exports = __webpack_public_path__ + "static/img/icon_yygh_yycg.cf6e16c.png";


//////////////////
// WEBPACK FOOTER
// ./static/icons/icon_yygh_yycg.png
// module id = 7pkm
// module chunks = 1